"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formHelperText = void 0;

var _stylitas = require("@creditas/stylitas");

var formHelperText = function formHelperText(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 300;\n  padding: 0;\n  margin: 0;\n"])), _stylitas.utilities.typography.form(theme));
};

exports.formHelperText = formHelperText;